app.controller('ContactController', ['$scope','$http','Config','helper', 'userJourney', function($scope,$http,Config,helper, userJourney){
	$scope.name = '';
	$scope.email = '';
	$scope.telephone = '';
	$scope.message = '';
	$scope.sent = false;
	$scope.user_journey = userJourney.getJourney();

	$scope.init = function(){
		helper.hideFullLoader();
	}

	$scope.submit = function(form){
		if(form.$valid){
			//send an ajax call to save the message and send an email notification

			$http({
				method: 'POST',
				data: {data: $scope.user_journey},
				url: Config.base_url+'contact/save_journey_and_source'
			  }).then(function(response) {
					if(response.data.status=="success"){
						var journey_and_source = response.data.data;

						data = {
								'name':form.name.$modelValue,
								'email':form.email.$modelValue,
								'telephone':form.telephone.$modelValue,
								'message':form.message.$modelValue,
								'ip':$('#ip').val(),
								'user-agent': $('#user-agent').val(),
								'token': $('#user_token').val(),
								'brand':Config.brand_key,
								'user-journey-id':journey_and_source.user_journey_id,
								'came-from':journey_and_source.camefrom,
								'utm-campaign':journey_and_source.utm_campaign,
								'utm-medium':journey_and_source.utm_medium,
								'utm-source':journey_and_source.utm_source
							};
						
						$http({
						method: 'POST',
						data:data,
						url: Config.api_url+'message',
						headers:{
							'authorization':Config.api_key
						}
						}).then(function(response) {
							$scope.sent = true;
							// ga('send', 'pageview', {page: '/contact.html'});
							gtag('event', 'page_view', {page_location: Config.base_url + 'contact.html'});
						}, function(response) {
							console.log(response);
						}
					);
				}
			})
		}
	}
}]);